const EntryDetailsView = async () => import('@/views/infoboard/EntryDetailsView.vue')
import type { _RouteLocationBase } from 'vue-router'

export default [
  {
    path: '/infoboard/show/:id',
    name: 'infoboard_show_entry',
    component: EntryDetailsView,
    props: (route: _RouteLocationBase) => {
      return { id: parseInt(route.params.id as string) }
    }
  }
]
